import React, { useState, useEffect } from "react";

const LimitSetTable = ({
  limitSetList,
  filterInputLimitSet,
  setFilterInputLimitSet,
  idLimitSet,
  setIdLimitSet,
  setBetTypeOptionSelected,
  setBetTypeName,
}) => {
  const [filteredData, setFilteredData] = useState([]);

  //This useEffect filters the Tracks table according to Book Description.
  useEffect(() => {
    let filteredData = limitSetList;
    //Books input filter
    if (filterInputLimitSet) {
      filteredData = filteredData.filter((item) =>
        item.LimitSetName.toLowerCase().includes(
          filterInputLimitSet.toLowerCase(),
        ),
      );
    }
    setFilteredData(filteredData);
  }, [limitSetList, filterInputLimitSet]);

  // Headers
  let headers,
    limitSetTable = [];
  headers = (
    <tr className="text-center">
      <th hidden>IDLimitSet</th>
      <th>LimitSet</th>
    </tr>
  );

  // The main LimitSet table
  if (limitSetList) {
    limitSetTable = filteredData.map((item, i) => {
      if (idLimitSet) {
        var className =
          item.LimitSetID === idLimitSet ? "classActiveMultiselect" : "";
      }

      return (
        <React.Fragment key={i}>
          <tr
            key={item.LimitSetID}
            onClick={() => handleLimitSetChange(item.LimitSetID)}
            className={className}
            style={{ cursor: "pointer" }}
          >
            <td key={"LimitSetID" + i} className="d-none">
              {item.LimitSetID}
            </td>
            {/* LimitSet Name */}
            <td
              key={"LimitSetName" + i}
              style={{
                verticalAlign: "middle",
                textAlign: "center",
                whiteSpace: "normal",
                fontSize: "14px",
              }}
            >
              {item.LimitSetName}
            </td>
          </tr>
        </React.Fragment>
      );
    });
  }

  // This constant is used internally to set the selected Track Name or Track Code in the filters
  const handleInputFilterChange = (event) => {
    setFilterInputLimitSet(event.target.value);
  };

  // This function displays the tracks associated with each book
  const handleLimitSetChange = (idLimitSet) => {
    setIdLimitSet(idLimitSet);
    setBetTypeOptionSelected(0);
    setBetTypeName("Win");
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          LimitSet List
        </p>
      </div>
      <div style={{ textAlign: "center" }}>
        <input
          value={filterInputLimitSet}
          onChange={handleInputFilterChange}
          placeholder={"LimitSet Search..."}
          className="form-control mb-1"
        />
      </div>
      <div
        className="tablesLimits"
        style={{
          overflow: "auto",
        }}
      >
        <table className="table table-hover table-sm mt-2">
          <thead
            style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
          >
            {headers}
          </thead>
          <tbody className="table-lg">{limitSetTable}</tbody>
        </table>
      </div>
    </div>
  );
};

export default LimitSetTable;
